
(function () {
  const GIFT_ID = 67809880932633;
  const MINIMUM = 350000; // ₱3,500 in centavos
  const ROOT = window.Shopify?.routes?.root || "/";

  let busy = false;
  let pending = false;
  let timer;

  async function request(path, data) {
    const response = await fetch(ROOT + path, {
      method: data ? "POST" : "GET",
      headers: data
        ? { "Content-Type": "application/json" }
        : {},
      body: data ? JSON.stringify(data) : undefined,
      credentials: "same-origin",
      cache: "no-store"
    });

    if (!response.ok) {
      throw new Error("Cart request failed: " + response.status);
    }

    return response.json();
  }

  function scheduleCheck() {
    clearTimeout(timer);
    timer = setTimeout(checkFreeGift, 100);
  }

  // Expose function for manual testing
  window.hanabishiCheckFreeGift = scheduleCheck;

  async function checkFreeGift() {
    if (busy) {
      pending = true;
      return;
    }

    busy = true;

    try {
      const cart = await request("cart.js");

      // Find free gift items first
      const gifts = cart.items.filter(
        item => Number(item.variant_id) === GIFT_ID
      );

      // Calculate cart subtotal after discounts,
      // excluding the free gift.
      const giftTotal = gifts.reduce(
        (sum, gift) =>
          sum + Number(gift.final_line_price ?? gift.line_price ?? 0),
        0
      );

      const subtotal = Math.max(
        0,
        Number(cart.total_price || 0) - giftTotal
      );

      let changed = false;

      if (subtotal >= MINIMUM && gifts.length === 0) {
        // Automatically add one plushie.
        await request("cart/add.js", {
          items: [{ id: GIFT_ID, quantity: 1 }]
        });

        changed = true;
      } else if (subtotal < MINIMUM) {
        // Remove the gift if no longer eligible.
        for (const gift of gifts) {
          await request("cart/change.js", {
            id: gift.key,
            quantity: 0
          });
          changed = true;
        }
      } else {
        // Allow only one plushie.
        for (let i = 0; i < gifts.length; i++) {
          const quantity = i === 0 ? 1 : 0;

          if (gifts[i].quantity !== quantity) {
            await request("cart/change.js", {
              id: gifts[i].key,
              quantity
            });
            changed = true;
          }
        }
      }

      if (changed) {
        const updatedCart = await request("cart.js");

        if (/\/cart\/?$/.test(location.pathname)) {
          if (typeof window.cartPageUpdate === "function") {
            window.cartPageUpdate(updatedCart);
          } else {
            location.reload();
          }
        } else if (typeof window.buildCart === "function") {
          window.buildCart(updatedCart, false);
        }

        console.log("Free gift cart updated.");
      }

    } catch (error) {
      console.error("Free gift error:", error);
    } finally {
      busy = false;

      if (pending) {
        pending = false;
        scheduleCheck();
      }
    }
  }

  $(function () {
    scheduleCheck();

    // Listen for YUVA Ajax cart updates.
    $(document).ajaxComplete(function (event, xhr, settings) {
      const method = (settings.type || "GET").toUpperCase();
      const path = new URL(settings.url, location.href).pathname;

      if (
        method === "POST" &&
        /\/cart\/(add|change|update|clear)(\.js)?$/.test(path)
      ) {
        scheduleCheck();
      }
    });
  });
})();


/* HANABISHI FREE GIFT - CART CONTROL RESTRICTIONS */
(function () {
  const GIFT_PATH =
    "/products/not-for-sale-hanabishi-gift-for-free";

  // YUVA cart drawer and cart page containers
  const rows = [
    ".media-link",
    "tr",
    ".cart-item",
    "[data-cart-item]"
  ];

  // Controls customers should not use on the free gift
  const controls = [
    ".quantity",
    ".quantity-button",
    ".ajaxcart__qty-num",
    ".line_item_change",
    ".line_item_remove",
    ".sd_mini_removeproduct"
  ];

  const selectors = rows.flatMap(row =>
    controls.map(control =>
      `${row}:has(a[href*="${GIFT_PATH}"]) ${control}`
    )
  );

  const style = document.createElement("style");
  style.id = "hanabishi-free-gift-lock";

  style.textContent = `
    ${selectors.join(",\n")} {
      display: none !important;
    }
  `;

  document.head.appendChild(style);

  console.log("Hanabishi gift quantity controls restricted");
})();


/* Hide Buy It Now on Free Gift product only */
(function () {
  const giftProductPath =
    "/products/not-for-sale-hanabishi-gift-for-free";

  const currentPath = window.location.pathname.replace(/\/$/, "");

  if (currentPath !== giftProductPath) return;

  const style = document.createElement("style");

  style.textContent = `
    .shopify-payment-button,
    .shopify-payment-button__button {
      display: none !important;
    }
  `;

  document.head.appendChild(style);
})();


/* CUSTOM BUY IT NOW WITH AUTOMATIC FREE GIFT */
(function () {
  const GIFT_ID = 67809880932633;
  const MINIMUM = 350000; // PHP 3,500 in centavos
  const ROOT = (window.Shopify?.routes?.root || "/").replace(/\/?$/, "/");
  const GIFT_PATH = "/products/not-for-sale-hanabishi-gift-for-free";
  const pathname = location.pathname.replace(/\/$/, "");

  // Only on regular product pages, never on the free-gift page.
  const isProductPage =
    /^\/products\/[^/]+$/.test(pathname) ||
    /^\/collections\/[^/]+\/products\/[^/]+$/.test(pathname);

    if (!isProductPage || pathname.endsWith(GIFT_PATH)) return;

  async function api(path, body) {
    const response = await fetch(ROOT + path, {
      method: body ? "POST" : "GET",
      credentials: "same-origin",
      cache: "no-store",
      headers: body
        ? { "Content-Type": "application/json", Accept: "application/json" }
        : {},
      body: body ? JSON.stringify(body) : undefined
    });

    if (!response.ok) {
      throw new Error("Shopify cart request failed (" + response.status + ").");
    }

    return response.json();
  }

  async function updateGift() {
    let cart = await api("cart.js");

    if (cart.currency && cart.currency !== "PHP") {
      throw new Error("This gift threshold is configured for PHP carts only.");
    }

    // Find free gift items first
    let gifts = cart.items.filter(
      item => Number(item.variant_id) === GIFT_ID
    );

    // Calculate discounted subtotal excluding gift
    const giftTotal = gifts.reduce(
      (sum, gift) =>
        sum + Number(gift.final_line_price ?? gift.line_price ?? 0),
      0
    );

    const subtotal = Math.max(
      0,
      Number(cart.total_price || 0) - giftTotal
    );

    if (subtotal >= MINIMUM && gifts.length === 0) {
      await api("cart/add.js", {
        items: [{ id: GIFT_ID, quantity: 1 }]
      });
    } else if (subtotal < MINIMUM) {
      for (const gift of gifts) {
        await api("cart/change.js", {
          id: gift.key,
          quantity: 0
        });
      }
    } else if (gifts.length) {
      // Normalize duplicate gifts.
      for (let i = gifts.length - 1; i >= 0; i--) {
        const quantity = i === 0 ? 1 : 0;

        if (gifts[i].quantity !== quantity) {
          await api("cart/change.js", {
            id: gifts[i].key,
            quantity
          });
        }
      }
    }

    cart = await api("cart.js");
    gifts = cart.items.filter(
      item => Number(item.variant_id) === GIFT_ID
    );

    // Prevent checkout if the gift is not confirmed free.
    if (
      subtotal >= MINIMUM &&
      (
        gifts.length !== 1 ||
        gifts[0].quantity !== 1 ||
        Number(gifts[0].final_line_price) !== 0
      )
    ) {
      for (const gift of gifts) {
        try {
          await api("cart/change.js", {
            id: gift.key,
            quantity: 0
          });
        } catch (error) {
          console.error("Gift cleanup failed:", error);
        }
      }

      throw new Error(
        "The free-gift discount could not be confirmed. Checkout was stopped."
      );
    }
  }

  function setupBuyNow() {
    document.querySelectorAll("form.main-product-form").forEach(form => {
      const nativeButton = form.querySelector(".shopify-payment-button");
      const addToCart = form.querySelector(".Sd_addProduct");

      if (!nativeButton || !addToCart ||
          nativeButton.dataset.giftCustomCheckout) return;

      nativeButton.dataset.giftCustomCheckout = "1";

      const button = document.createElement("button");
      button.type = "button";
      button.className = "hanabishi-gift-buy-now";
      button.textContent = "BUY IT NOW";

      button.style.cssText = `
        display: block;
        width: 100%;
        min-height: 54px;
        margin-top: 8px;
        background: #fff;
        color: #111;
        border: 1px solid #111;
        border-radius: 4px;
        cursor: pointer;
        font: inherit;
        max-width: 500px;
        flex: 0 0 100%;
        min-width: auto !important;
        margin: 0 0 10px 0;
      `;

      nativeButton.style.setProperty("display", "none", "important");
      nativeButton.insertAdjacentElement("afterend", button);

      button.addEventListener("click", async () => {
        if (button.disabled) return;

        if (addToCart.disabled) {
          alert("Please select an available product variant.");
          return;
        }

        const formData = new FormData(form);

        if (!formData.get("id")) {
          alert("Please select a product variant first.");
          return;
        }

        button.disabled = true;
        button.textContent = "PREPARING CHECKOUT...";

        try {
          // Add selected product, preserving variant,
          // quantity and product form properties.
          const response = await fetch(ROOT + "cart/add.js", {
            method: "POST",
            credentials: "same-origin",
            headers: { Accept: "application/json" },
            body: formData
          });

          if (!response.ok) {
            throw new Error("Could not add the product to the cart.");
          }

          // Add/remove gift and validate before checkout.
          await updateGift();

          // Checkout with the updated cart.
          window.location.assign(ROOT + "checkout");

        } catch (error) {
          console.error("Custom Buy It Now failed:", error);

          alert(
            error.message +
            " Your selected product may already be in the cart. " +
            "Please check your cart before trying again."
          );

          button.disabled = false;
          button.textContent = "BUY IT NOW";
        }
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupBuyNow, {
      once: true
    });
  } else {
    setupBuyNow();
  }
})();
